import { createFileRoute, redirect } from "@tanstack/react-router";

import { hasPermission } from "@/modules/auth/lib/permissions";
import { WarrantyPage } from "@/modules/warranty/pages/WarrantyPage";

export const Route = createFileRoute("/__authed/m/repairs/warranty")({
	beforeLoad({ context }) {
		const user = "user" in context ? context.user : undefined;

		if (!hasPermission(user, "see_repairs")) {
			throw redirect({ to: "/m/dashboard" });
		}
	},
	component: WarrantyPage,
});
